'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiImage = require('@spp/ui-image');

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageMarkup = function imageMarkup(theme, title, imageAsset) {
    if (!imageAsset) {
        return null;
    }
    return _react2.default.createElement(_uiImage.ImageAsset, (0, _extends3.default)({ theme: theme, caption: title }, imageAsset, { testTag: '@spp/ui-byline:image-asset' }));
};

var descriptionMarkup = function descriptionMarkup(theme, description) {
    if (!description) {
        return null;
    }
    return _react2.default.createElement(
        'span',
        { className: theme },
        description
    );
};

var authorNameMarkup = function authorNameMarkup(author, theme, originator, stylizr) {
    if (originator.contacts) {
        var email = originator.contacts.filter(function (contact) {
            return contact.type === 'email';
        });
        var web = originator.contacts.filter(function (contact) {
            return contact.type === 'web';
        });

        if (web.length) {
            return _react2.default.createElement(
                'a',
                {
                    href: web[0].value,
                    className: theme
                },
                stylizr(author.text.value, author.text.markup)
            );
        }
        if (email.length) {
            return _react2.default.createElement(
                'a',
                {
                    href: 'mailto:' + email[0].value,
                    className: theme
                },
                stylizr(author.text.value, author.text.markup)
            );
        }
    }
    return _react2.default.createElement(
        'span',
        null,
        stylizr(author.text.value, author.text.markup)
    );
};
var findAuthorById = function findAuthorById(originators, id) {
    return originators.filter(function (author) {
        return author.id === id;
    })[0];
};

var markupAuthorRenderer = function markupAuthorRenderer(author, isLast, stylizr, theme, id) {
    return _react2.default.createElement(
        'li',
        { className: theme.listItem, key: id },
        stylizr(author.text.value, author.text.markup),
        isLast
    );
};

var originatorAuthorRenderer = function originatorAuthorRenderer(author, isLast, originators, stylizr, theme) {
    var originator = findAuthorById(originators, author.originatorId);
    return _react2.default.createElement(
        'li',
        { className: theme.listItem, key: author.originatorId },
        imageMarkup(theme.image, author.title, originator.imageAsset),
        authorNameMarkup(author, theme.link, originator, stylizr),
        descriptionMarkup(theme.description, originator.description),
        isLast
    );
};

var authorRenderer = function authorRenderer(author, isLast, originators, stylizr, theme, id) {
    if (author.originatorId) {
        return originatorAuthorRenderer(author, isLast, originators, stylizr, theme);
    }
    return markupAuthorRenderer(author, isLast, stylizr, theme, id);
};

var authorsList = function authorsList(authors, listFormat, originators, stylizr, theme) {
    var authorsCount = authors.length;
    var isLast = function isLast(i) {
        if (i >= authorsCount - 1) {
            return '';
        }
        if (i === authorsCount - 2 && listFormat.lastSeparator) {
            return _react2.default.createElement(
                'span',
                { className: theme.separator },
                listFormat.lastSeparator
            );
        }
        return _react2.default.createElement(
            'span',
            { className: theme.separator },
            listFormat.separator
        );
    };
    return authors.map(function (author, i) {
        return authorRenderer(author, isLast(i), originators, stylizr, theme, i);
    });
};

var Byline = function Byline(_ref) {
    var authors = _ref.authors,
        listFormat = _ref.listFormat,
        listTitle = _ref.listTitle,
        originators = _ref.originators,
        stylizr = _ref.stylizr,
        theme = _ref.theme;
    return _react2.default.createElement(
        'div',
        { className: theme.root, 'data-test-tag': '@spp/ui-byline' },
        _react2.default.createElement(
            'span',
            { className: theme.before },
            listFormat.beforeList
        ),
        _react2.default.createElement(
            'ul',
            { className: theme.authorList, 'aria-label': listTitle, 'data-test-tag': '@spp/ui-byline:authors' },
            authorsList(authors, listFormat, originators, stylizr, theme)
        )
    );
};

// https://github.schibsted.io/smp-distribution/format/blob/master/iris/v4/objects.md#originator
Byline.propTypes = {
    authors: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        text: _irisPropTypes.objects.text,
        originatorId: _propTypes2.default.string
    })).isRequired,
    listFormat: _propTypes2.default.shape({
        beforeList: _propTypes2.default.string,
        separator: _propTypes2.default.string,
        lastSeparator: _propTypes2.default.string
    }),
    listTitle: _propTypes2.default.string,
    originators: _propTypes2.default.arrayOf(_irisPropTypes.objects.originator),
    theme: _propTypes2.default.shape({
        authorList: _propTypes2.default.string,
        before: _propTypes2.default.string,
        description: _propTypes2.default.string,
        image: _propTypes2.default.string,
        link: _propTypes2.default.string,
        listItem: _propTypes2.default.string,
        root: _propTypes2.default.string,
        title: _propTypes2.default.string
    }),
    stylizr: _propTypes2.default.func.isRequired
};

Byline.defaultProps = {
    authors: [],
    originators: [],
    listFormat: {
        separator: ', '
    },
    listTitle: '',
    stylizr: function stylizr(text) {
        return text;
    },
    theme: {}
};

exports.default = Byline;
//# sourceMappingURL=Byline.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-byline/lib/cjs/Byline/Byline.js
 ** module id = 577
 ** module chunks = 1
 **/